module.exports = __webpack_public_path__ + "img/hr-wooden-particle-19.6e818085.png";